<mat-icon class="no-flex status-icon {{ticket?.status}}">
  {{ ticket?.status == 'CLOSED' ? 'check_circle' : ''}}
  {{ ticket?.status == 'INITIATED' ? 'outbound' : ''}}
  {{ ticket?.status == 'RESPONDED' ? 'replay_circle_filled' : ''}}
  {{ ticket?.status == 'MORE_INFO_NEEDED' ? 'info' : ''}}
</mat-icon>